import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import React from 'react';
import { AppLink } from '@finect/tabular-core/AppLink';
import { Link } from 'react-router-dom';
import { PercentLabel } from '../../Labels';
var getPerformance = function getPerformance(category, period) {
  var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'accumulated';
  var found = category.stats.performance.find(function (perf) {
    return perf.period === period && perf.type === type;
  });
  if (found) {
    return found.value;
  }
  return null;
};
var getCategoryRow = function getCategoryRow(productType, cat, commonPath) {
  return {
    match: false,
    cells: [{
      params: {
        textAlign: 'left'
      },
      _orderableValue: cat.name,
      component: React.createElement(AppLink, {
        as: Link,
        to: "/".concat(commonPath, "/categorias/").concat(cat.id, "-").concat(cat.alias)
      }, cat.name)
    }, {
      params: {
        textAlign: 'right'
      },
      _orderableValue: cat.stats.funds,
      component: React.createElement(AppLink, {
        as: Link,
        to: "/".concat(commonPath, "/listado?category=").concat(cat.id, "&order=-M0&view=table")
      }, cat.stats.funds)
    }, {
      params: {
        textAlign: 'right'
      },
      _orderableValue: getPerformance(cat, 'W1'),
      component: React.createElement(PercentLabel, {
        withNegative: true,
        withPositiveSign: true,
        withSparkline: true,
        value: getPerformance(cat, 'W1')
      })
    }, {
      params: {
        textAlign: 'right'
      },
      _orderableValue: getPerformance(cat, 'M1'),
      component: React.createElement(PercentLabel, {
        withNegative: true,
        withPositiveSign: true,
        withSparkline: true,
        value: getPerformance(cat, 'M1')
      })
    }, {
      params: {
        textAlign: 'right'
      },
      _orderableValue: getPerformance(cat, 'M0'),
      component: React.createElement(PercentLabel, {
        withNegative: true,
        withPositiveSign: true,
        withSparkline: true,
        value: getPerformance(cat, 'M0')
      })
    }, {
      params: {
        textAlign: 'right'
      },
      _orderableValue: getPerformance(cat, 'M12'),
      component: React.createElement(PercentLabel, {
        withNegative: true,
        withPositiveSign: true,
        withSparkline: true,
        value: getPerformance(cat, 'M12')
      })
    }, {
      params: {
        textAlign: 'right'
      },
      _orderableValue: getPerformance(cat, 'M36'),
      component: React.createElement(PercentLabel, {
        withNegative: true,
        withPositiveSign: true,
        withSparkline: true,
        value: getPerformance(cat, 'M36', 'annualized')
      })
    }, {
      params: {
        textAlign: 'right'
      },
      _orderableValue: getPerformance(cat, 'M60'),
      component: React.createElement(PercentLabel, {
        withNegative: true,
        withPositiveSign: true,
        withSparkline: true,
        value: getPerformance(cat, 'M60', 'annualized')
      })
    }, {
      params: {
        textAlign: 'right'
      },
      _orderableValue: getPerformance(cat, 'M120'),
      component: React.createElement(PercentLabel, {
        withNegative: true,
        withPositiveSign: true,
        withSparkline: true,
        value: getPerformance(cat, 'M120', 'annualized')
      })
    }]
  };
};
export var getRows = function getRows(productType) {
  var commonPath = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var array = arguments.length > 2 ? arguments[2] : undefined;
  var broad = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  var filter = arguments.length > 4 ? arguments[4] : undefined;
  var excludeCategories = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
  return array.filter(function (cat) {
    return broad ? cat.broad && cat.broad.includes(broad) : true;
  }).filter(function (cat) {
    return excludeCategories ? !filter.includes(cat.id) : filter.includes(cat.id);
  }).sort(function (_a, _b) {
    return _b.stats.assets - _a.stats.assets;
  }).map(function (item) {
    return getCategoryRow(productType, item, commonPath);
  });
};
export var getPlansRows = function getPlansRows(productType) {
  var commonPath = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var array = arguments.length > 2 ? arguments[2] : undefined;
  var broad = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  var filter = arguments.length > 4 ? arguments[4] : undefined;
  var excludeCategories = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
  return array.sort(function (_a, _b) {
    return _b.stats.assets - _a.stats.assets;
  }).map(function (item) {
    return getCategoryRow(productType, item, commonPath);
  });
};
export var getHomeCardsPerformance = function getHomeCardsPerformance(array) {
  var broad = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var filter = arguments.length > 2 ? arguments[2] : undefined;
  var excludeCategories = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  return array.filter(function (cat) {
    return broad ? cat.broad === broad : true;
  }).filter(function (cat) {
    return excludeCategories ? !filter.includes(cat.id) : filter.includes(cat.id);
  }).sort(function (_a, _b) {
    return _b.stats.assets - _a.stats.assets;
  }).map(function (item) {
    return {
      id: item.id,
      funds: item.stats.funds,
      performance: [{
        period: 'W1',
        label: 'Semana',
        value: getPerformance(item, 'W1')
      }, {
        period: 'M1',
        label: 'Mes',
        value: getPerformance(item, 'M1')
      }, {
        period: 'M12',
        label: '12 meses',
        value: getPerformance(item, 'M12')
      }]
    };
  });
};